import { render, staticRenderFns } from "./CommentMessage.vue?vue&type=template&id=c3df39fe&scoped=true&"
import script from "./CommentMessage.vue?vue&type=script&lang=js&"
export * from "./CommentMessage.vue?vue&type=script&lang=js&"
import style0 from "./CommentMessage.vue?vue&type=style&index=0&id=c3df39fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3df39fe",
  null
  
)

export default component.exports